import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from "@material-ui/core/Button";
import {deleteACompany, loadCompanysData, saveACompany, updateACompany} from "../../redux/modules/company";
import {
	deleteATowCompanyDriver,
	loadTowCompanyDriversData,
	saveATowCompanyDriver,
	updateATowCompanyDriver,
	clearTowCompanyDriverErrorMsg,
} from "../../redux/modules/towcompanydriver";
import {DEFAULT_VESPAAN_SERVER} from "../../utils/MainConstants";
import InputMask from 'react-input-mask'

//import {loadCompanysData} from "../../redux/modules/company";


import {connect} from "react-redux";
import PropTypes from "prop-types";
import {bindActionCreators} from "redux";
//import {loadCamerasData} from "../../redux/modules/camera";
import {withStyles} from "@material-ui/core";
import DynamicTable from "./DynamicTable";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import GridList from "@material-ui/core/GridList";
import CardVehicleInformation from "./CardVehicleInformation";
import CardCompanyInformation from "./CardCompanyInformation";
import CardStorageLotInformation from "./CardStorageLotInformation";
import FormHelperText from "@material-ui/core/FormHelperText";
import * as MainConstants from "../../utils/MainConstants";
import ExpandableTowCompanyDriverInformation from "./ExpandableTowCompanyDriverInformation";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
//import {loadLocationsData} from "../../redux/modules/location";


const styles = theme => ({
	main: {
		width: 'auto',
		display: 'block', // Fix IE 11 issue.
		marginLeft: theme.spacing.unit * 3,
		marginRight: theme.spacing.unit * 3,
		[theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
			width: 400, marginLeft: 'auto', marginRight: 'auto',
		},
	}, paper: {
		marginTop: theme.spacing.unit * 8,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
	}, avatar: {
		margin: theme.spacing.unit, backgroundColor: theme.palette.secondary.main,
	}, form: {
		width: '100%', // Fix IE 11 issue.
		marginTop: theme.spacing.unit,
	}, submit: {
		marginTop: theme.spacing.unit * 3,
	}, formControl: {
		margin: theme.spacing.unit, minWidth: 120, color: 'red',
	}, formControl2: {
		//margin: theme.spacing.unit,
		//minWidth: 120,
		marginLeft: 5,
	}, selectEmpty: {
		marginTop: theme.spacing.unit * 2,
	}, button: {
		marginTop: theme.spacing.unit * 3,
		marginLeft: theme.spacing.unit,
		backgroundColor: "#e2580d",
		color: "black",
		textTransform: "unset !important",
		width: '80%',
	}, gridList: {
		width: '80%', height: '100%', maxHeight: 800,
	},
});


class TowCompanyDriversForm extends React.Component {
	
	
	state = {
		
		//selectedLocation:{},
		selectedTowCompanyDriver: {"id":""},
		selectedCompany: {},
		inputFieldShrinkState: true,
		numberShrink: false, //Jut sfor alter I can add a shrink flag for each filed.
		showStoragelotSavedDialog: false
		
	};
	
	
	constructor(props) {
		super(props);
		this.storageCardList = null;
		this.editRecord = this.editRecord.bind(this);
		this.deleteRecord = this.deleteRecord.bind(this);
		this.clearFields = this.clearFields.bind(this);
		this.refresh = this.refresh.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleUpdate = this.handleUpdate.bind(this);
		//this.handleCompanyNumberChange = this.handleCompanyNumberChange.bind(this);
		this.handleFirstNameChange = this.handleFirstNameChange.bind(this);
		this.handleLastNameChange = this.handleLastNameChange.bind(this);
		
		
		this.handleEmailChange = this.handleEmailChange.bind(this);
		
		this.handlePhoneChange = this.handlePhoneChange.bind(this);
		
		
		this.handleCompanyChange = this.handleCompanyChange.bind(this);
		
		this.getListOfSrorageInformationExpandable = this.getListOfSrorageInformationExpandable.bind(this);
		
		this.handleClickShowSavedStoragelot = this.handleClickShowSavedStoragelot.bind(this);
		this.handleClickShowSavedStoragelotClose = this.handleClickShowSavedStoragelotClose.bind(this);
		
	}
	
	
	handleClickShowSavedStoragelot() {
		this.setState({showStoragelotSavedDialog: true});
	};
	
	
	handleClickShowSavedStoragelotClose() {
		let {clearTowCompanyDriverErrorMsg} = this.props;
		this.setState({showStoragelotSavedDialog: false});
		clearTowCompanyDriverErrorMsg();
	};
	
	handleSubmit() {
		
		
		let {saveATowCompanyDriver} = this.props;
		
		var tempStream = this.state.selectedTowCompanyDriver;
		
		
		saveATowCompanyDriver(DEFAULT_VESPAAN_SERVER.url, tempStream, this.state.selectedCompany.id);
		this.refresh();
		
	};
	
	handleUpdate() {
		let {updateATowCompanyDriver} = this.props;
		
		var tempStream = this.state.selectedTowCompanyDriver;
		tempStream.state = this.state.selectedState;
		tempStream.country = this.state.selectedCountry;
		tempStream.companyid = this.state.selectedCompany.id;
		updateATowCompanyDriver(DEFAULT_VESPAAN_SERVER.url, tempStream, this.state.selectedCompany.id);
		this.refresh();
		
	};
	
	
	handleFirstNameChange(event) {
		//event.preventDefault();
		this.setState(Object.assign(this.state.selectedTowCompanyDriver, {firstname: event.target.value}));
	}
	
	handleLastNameChange(event) {
		//event.preventDefault();
		this.setState(Object.assign(this.state.selectedTowCompanyDriver, {lastname: event.target.value}));
	}
	
	
	handleEmailChange(event) {
		//event.preventDefault();
		this.setState(Object.assign(this.state.selectedTowCompanyDriver, {email: event.target.value}));
	}
	
	handleCompanyChange(event) {
		let {loadTowCompanyDriversData} = this.props;
		//event.preventDefault();
		this.setState({selectedCompany: event.target.value});
		loadTowCompanyDriversData(DEFAULT_VESPAAN_SERVER.url, event.target.value.id);
		this.setState({numberShrink: true});
	}
	
	handleStateSelectionChange(event) {
		//let { loadCompanypropertysData  } = this.props;
		//event.preventDefault();
		this.setState({selectedState: event.target.value});
		//loadCompanypropertysData(DEFAULT_VESPAAN_SERVER.url,event.target.value.id );
		this.setState({numberShrink: true});
	}
	
	handleCountrySelectionChange(event) {
		//let { loadCompanypropertysData  } = this.props;
		//event.preventDefault();
		this.setState({selectedCountry: event.target.value});
		//loadCompanypropertysData(DEFAULT_VESPAAN_SERVER.url,event.target.value.id );
	}
	
	
	handlePhoneChange(event) {
		//event.preventDefault();
		this.setState(Object.assign(this.state.selectedTowCompanyDriver, {phone: event.target.value}));
		this.setState({numberShrink: true});
	}
	
	
	clearFields = (e) => {
		e.preventDefault();
		this.setState(state => ({
			inputFieldShrinkState: true
		}));
		
		
		var tempSelectedStorage = Object.assign({}, this.state.selectedTowCompanyDriver);
		Object.keys(tempSelectedStorage).map((key, index) => {
			tempSelectedStorage[key] = "";
		});
		this.setState({selectedTowCompanyDriver: tempSelectedStorage})
	};
	
	renderErrorFiled(data) {
	
	
	}
	
	refresh(event) {
		let {loadTowCompanyDriversData} = this.props;
		loadTowCompanyDriversData(DEFAULT_VESPAAN_SERVER.url, this.state.selectedCompany.id);
	}
	
	getListOfStoragelots() {
		let tempArray = this.props.towcompanydriversArray;
		let returnArray = [];
		if (tempArray) {
			returnArray = tempArray.map((s) => {
				s.editMode = false;
				return (< CardStorageLotInformation
					info={s}
					onEdit={this.editRecord}
					onDelete={this.deleteRecord(s.id)}> < /CardStorageLotInformation>);
			});
		}
		return (returnArray);
	}
	
	
	//This is for making teh police cards expanadble.
	getListOfSrorageInformationExpandable() {
		let tempArray = this.state.towcompanydriversArray; //this.props.towjobsArray;
		let returnArray = [];
		if (tempArray) {
			returnArray = tempArray.map((s) => {
				s.editMode = false;
				
				return (<ExpandableTowCompanyDriverInformation info={s} key={s.id} onEdit={this.editRecord}
				                                               onVehicleOwnerText={this.vehicleOwnerTextMode}
				                                               onTowAgentText={this.towAgentTextMode}
				                                               onDelete={this.deleteRecord}></ExpandableTowCompanyDriverInformation>);
			});
			//Duplicating array for testing only.
			//returnArray = returnArray.concat(returnArray);
			
		}
		return (returnArray);
	}
	
	getListOfCompaniesForSelection() {
		let tempArray = this.props.companysArray;
		let returnArray = [];
		if (tempArray) {
			returnArray = tempArray.map((s) => {
				return (< MenuItem
					key={s.id}
					value={s}> {s.name} < /MenuItem>);
				//return(<CardCompanyInformation info={s}  onEdit={this.editRecord}  onDelete={this.deleteRecord}></CardCompanyInformation> );
			});
		}
		return (returnArray);
	}
	
	
	render() {
		const {classes} = this.props;
		let usStates = MainConstants.getUSStates();
		let canStates = MainConstants.getCanadaStates();
		let availableCountries = MainConstants.getCountries();
		this.storageCardList = this.getListOfSrorageInformationExpandable();//this.getListOfStoragelots();
		this.companySelectList = this.getListOfCompaniesForSelection();
		return (< React.Fragment>
				< Typography
					variant="h6"
					gutterBottom>
					Storage
					Lot
					Information
				< /Typography>
				< Grid
					container
					spacing={24}>
					< Grid
						item
						xs={12}
						sm={12}>
						
						< Grid
							container>
							
							< Grid
								item
								xs={6}
								sm={6}>
								{/* < FormControl className = {classes.formControl}  required fullWidth >
                    < InputLabel htmlFor = "age-simple" > Location < /InputLabel>
                        < Select ref = {c => this.mySelect = c} value = {this.state.selectedLocation} onChange = {this.handleLocationChange}
                        inputProps = { { name: 'location', id : 'location', } } >
                        {this.props.locationsArray.map(n => (<MenuItem value= {n}   ref={n.id} inputProps = { { name: n.id , id :n.id  } } >{n.name}</MenuItem>))}

                        < /Select>
                < /FormControl>
                */}
								
								{/*
            <Grid container >
                <Grid item xs={5} sm={5} >
                    <TextField required id="number" name="number"  label="Number"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState || this.state.numberShrink  }}  value={this.state.selectedTowCompanyDriver.accountNumber} onChange={this.handleNumberChange}/>
                </Grid>
                <Grid item xs={2} sm={2} >
                </Grid>
                <Grid item xs={5} sm={5} >
                    <TextField required id="name" name="name"  label="Name on the account"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedTowCompanyDriver.accountName} onChange={this.handleCompanyNameChange}/>
                </Grid>
            </Grid>
            */}
								
								<Grid container>
									< Grid item xs={4} sm={4}>
									
									< /Grid>
									< Grid item xs={4} sm={4}>
									
									< /Grid>
									
									< Grid item xs={4} sm={4}>
										< FormControl className={classes.formControl}>
											< InputLabel htmlFor="age-helper" color="secondary"> Select Tow Company < /InputLabel>
											< Select value={this.state.selectedCompany} onChange={this.handleCompanyChange} useDefault={true}
											         defaultValue={this.state.selectedCompany.name}>
												{this.companySelectList}
											< /Select>
										< /FormControl>
									< /Grid>
								< /Grid>
								
								<Grid container>
									< Grid item xs={5} sm={5}>
										< TextField required id="firstname" name="firstname" label="First Name" fullWidth
										            InputLabelProps={{shrink: this.state.inputFieldShrinkState}}
										            value={this.state.selectedTowCompanyDriver.firstname}
										            onChange={this.handleFirstNameChange}/>
									< /Grid>
									<Grid item xs={2} sm={2}>
									</Grid>
									< Grid item xs={5} sm={5}>
										< TextField required id="lastname" name="lastname" label="Last Name" fullWidth
										            InputLabelProps={{shrink: this.state.inputFieldShrinkState}}
										            value={this.state.selectedTowCompanyDriver.lastname}
										            onChange={this.handleLastNameChange}/>
									< /Grid>
								
								
								< /Grid>
								
								
								< Grid container>
									
									< Grid item xs={5} sm={5}>
										<InputMask mask="(999) 999-9999" value={this.state.selectedTowCompanyDriver.phone}
										           onChange={this.handlePhoneChange}>
											{() => < TextField required id="phone" name="phone" label="Phone" fullWidth
											                   InputLabelProps={{shrink: this.state.inputFieldShrinkState}}/>}
										</InputMask>
									< /Grid>
									<Grid item xs={2} sm={2}>
									</Grid>
									
									<Grid item xs={5} sm={5}>
										<TextField required id="email" name="email" type="email" label="Email"
										           placeholder="email@example.com" fullWidth
										           InputLabelProps={{shrink: this.state.inputFieldShrinkState}}
										           value={this.state.selectedTowCompanyDriver.email} onChange={this.handleEmailChange}/>
									</Grid>
									
									
									{/*  It didn't work.
                        <Grid item xs={5} sm={5}>
                            <InputMask mask="**************************************@********************************************************"
                            value={this.state.selectedProperty.email} onChange={this.handleEmailChange}
                            >
                            {()=> <TextField  required id="email"  name="email"  label="Email"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}    /> }

                        </InputMask>
                        </Grid>
                        */}
									
									< Grid
										item
										xs={2}
										sm={2}>
									< /Grid>
									
									< Grid
										item
										xs={5}
										sm={5}>
									< /Grid>
									
									
									< Grid
										item
										xs={5}
										sm={5}>
									< /Grid>
									< Grid
										item
										xs={2}
										sm={2}>
									< /Grid>
									
									< Grid
										item
										xs={5}
										sm={5}>
										{/*
                <FormControl className={classes.formControl}>
                    <InputLabel htmlFor="age-helper">Company</InputLabel>
                        <Select
                            value={this.state.selectedCompany}
                            onChange={this.handleCompanyChange}
                            inputProps={{
                                name: 'age',
                                id: 'age-helper',
                            }}
                        >

                            {this.companySelectList}

                        </Select>
                    <FormHelperText>Select a Company </FormHelperText>
                </FormControl>
                */}
									< /Grid>
									
									
									< Grid
										item
										xs={5}
										sm={5}>
									< /Grid>
									< Grid
										item
										xs={2}
										sm={2}>
									< /Grid>
									
									< Grid
										item
										xs={5}
										sm={5}>
									< /Grid>
									
									< Grid
										item
										xs={5}
										sm={5}>
									< /Grid>
									< Grid
										item
										xs={2}
										sm={2}>
									< /Grid>
									
									< Grid
										item
										xs={5}
										sm={5}>
										{/* empty for now we can later*/}
									< /Grid>
									
									
									< Grid
										item
										xs={6}
										sm={6}>
										{((this.state.selectedTowCompanyDriver.id === undefined) || (this.state.selectedTowCompanyDriver.id === "")) && (
										< Button
											variant="contained"
											color="primary"
											onClick={this.handleSubmit}
											className={classes.button}>
											Add Driver
										< /Button>)}
									< /Grid>
									< Grid
										item
										xs={6}
										sm={6}>
										{(this.state.selectedTowCompanyDriver.id !=='')&&(
										< Button
											variant="contained"
											color="primary"
											onClick={this.handleUpdate}
											className={classes.button}>
											Update Driver
										< /Button>)}
									< /Grid>
									< Grid
										item
										xs={6}
										sm={6}>
										< Button
											variant="contained"
											color="primary"
											onClick={this.clearFields}
											className={classes.button}>
											Clear
											Fields
										< /Button>
									< /Grid>
									< Grid
										item
										xs={6}
										sm={6}>
										< Button
											variant="contained"
											color="primary"
											onClick={this.refresh}
											className={classes.button}>
											Refresh
										< /Button>
									< /Grid>
								< /Grid>
							< /Grid>
							< Grid item xs={1} sm={1}>
							< /Grid>
							< Grid item xs={5} sm={5}>
								{/*<DynamicTable  data={this.props.companysArray}  onEdit={this.editRecord}  onDelete={this.deleteRecord}> </DynamicTable> */}
								<Typography variant="h6" gutterBottom>
									There are {this.props.towcompanydriversArray.length} Drivers in your profile.
								</Typography>
								
								< GridList cellHeight={100} className={classes.gridList}>
									{this.storageCardList}
								< /GridList>
							< /Grid>
						< /Grid>
						
						
						< Grid
							container>
							{(this.props.errorCMsg) && (this.props.errorCMsg.message) && (< Grid
								item
								xs={12}>
								< TextField
									error
									id="outlined-error"
									label="Error - Operation Failed"
									value={" message = " + this.props.errorCMsg.message + " details = " + this.props.errorCMsg.details + " Time = " + this.props.errorCMsg.timestamp}
									className={classes.textField}
									margin="normal"
									variant="outlined"
									disabled={true}
									multiline={true}
								/>
							< /Grid>)}
							{/*
                    {  !this.props.errorCMsg && (
                    <Grid item xs={12}   >
                        <TextField error id="outlined-error" label="Great! - Operation Success" value= "Nothing here"
                        className={classes.textField} margin="normal"  variant="outlined" disabled={true}  multiline={true}/>
                    </Grid>)
                    }
                    */}
						<
        /Grid>
					< /Grid>
					
					{/* This is for submit event error/success display */}
					<Dialog
						open={this.state.showStoragelotSavedDialog}
						onClose={this.handleClickShowSavedStoragelotClose}
						scroll={'paper'}
						classes={{
							paper: classes.formControl2,
						}}
						aria-labelledby="scroll-dialog-title"
						aria-describedby="scroll-dialog-description"
						maxWidth="xl"
					>
						<DialogTitle id="scroll-dialog-title">Driver Information</DialogTitle>
						<DialogContent id="farshids" dividers="paper">
							
							{(this.props.errorCMsg.status == 200) && (<div>
								The Operation was SUCCESSFUL! Please refresh the list by pressing the refresh button
								- {this.props.errorCMsg.status} {this.props.errorCMsg.statusText}
							</div>)}
							{(this.props.errorCMsg.status != 200) && (this.props.errorCMsg.status != null) && (<div>
								The Operation FAILED, please try again!
								- {this.props.errorCMsg.status} - {this.props.errorCMsg.statusText}
							</div>)}
						
						</DialogContent>
						<DialogActions>
							{/*
																										<Tooltip title="Selected entities will receive police notice">
																											<Button  color="primary" onClick={this.sendEmail}>Send EMAIL</Button>
																										</Tooltip>
																										*/}
							
							<Button onClick={this.handleClickShowSavedStoragelotClose} color="secondary">Close</Button>
						</DialogActions>
					</Dialog>
				< /Grid>
			< /React.Fragment>);
	}//end of render
	
	
	editRecord(singleRowData) {
		this.setState({inputFieldShrinkState: true});
		this.setState({selectedTowCompanyDriver: singleRowData});
		
		
	}
	
	
	deleteRecord(argProcessId) {
		//alert('I am deleting ' + argCameraId);
		let {deleteATowCompanyDriver, loadTowCompanyDriversData} = this.props;
		deleteATowCompanyDriver(DEFAULT_VESPAAN_SERVER.url, this.state.selectedCompany.id, argProcessId);
		loadTowCompanyDriversData(DEFAULT_VESPAAN_SERVER.url, this.state.selectedCompany.id);
	}
	
	
	componentWillMount() {
		let {loadTowCompanyDriversData, loadCompanysData} = this.props;
		//loadTowCompanyDriversData(DEFAULT_VESPAAN_SERVER.url);
		//loadLocationsData("http://localhost:9065/" );
		
		loadCompanysData(DEFAULT_VESPAAN_SERVER.url);
		
		this.setState({
			errorCMsg: {}
		});
		
		if ((this.props.companysArray != null) && (this.props.companysArray.length >= 1)) {
			this.setState({selectedCompany: this.props.companysArray[0]});
			loadTowCompanyDriversData(DEFAULT_VESPAAN_SERVER.url, this.props.companysArray[0].id);
		}
	}
	
	componentDidMount() {
		/*if ((this.props.companysArray != null) && (this.props.companysArray.length >= 1)) {
				this.setState({selectedCompany: this.props.companysArray[0]});
		}*/
		
	}
	
	componentWillReceiveProps(nextProps) {
		if (this.props.towcompanydriversArray !== nextProps.towcompanydriversArray) {
			this.setState({
				towcompanydriversArray: nextProps.towcompanydriversArray
			});
		}
		if ((nextProps != null) && (nextProps.companysArray != null) && (nextProps.companysArray.length >= 1) && (this.props.companysArray !== nextProps.companysArray)) {
			this.setState({selectedCompany: nextProps.companysArray[0]});
			//selectACompany(nextProps.companysArray[0].id);
		}
		if (nextProps.errorCMsg.status != null) {
			if (nextProps.errorCMsg.status != null) {
				this.handleClickShowSavedStoragelot();
			}
		}
	}
	
	
}//end of class

TowCompanyDriversForm.propTypes = {
	classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
	return {
		towcompanydriversArray: state.towcompanydriver.towcompanydriversArray,
		truckDeleteResponse: state.towcompanydriver.deleteTowCompanyDriverResp,
		truckSaveResponse: state.towcompanydriver.saveTowCompanyDriverResp,
		companysArray: state.company.companysArray, //locationsArray:state.location.locationsArray,
		//vcArray:state.videocontroller.vcArray,
		//camerasArray:state.camera.camerasArray,
		errorCMsg: state.towcompanydriver.errorCMsg,
	};
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
		loadTowCompanyDriversData: loadTowCompanyDriversData,
		deleteATowCompanyDriver: deleteATowCompanyDriver,
		saveATowCompanyDriver: saveATowCompanyDriver,
		updateATowCompanyDriver: updateATowCompanyDriver,
		loadCompanysData: loadCompanysData,
		clearTowCompanyDriverErrorMsg: clearTowCompanyDriverErrorMsg,
		
	}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(TowCompanyDriversForm));
